<template>
    <div class="footer">
      <div class="content">
        <div class="msg">
          <p>
            <i class="iconfont">&#xe63a;</i>
            重庆市两江新区礼嘉金泰智能产业园二期15栋601
          </p>
          <p>
            <i class="iconfont">&#xe635;</i>
            023-67139735
          </p>
          <p>
            <i class="iconfont">&#xe638;</i>
            vcbyunying@vcbeat.net
          </p>
        </div>
        <div class="hrefs">
          <p class="title">
            <span>友情链接</span>
            <span @click="handleClickIndex">关于我们</span>
            <span @click="contact_model = true">联系我们</span>
          </p>
          <div>
            <!-- <a href="https://vcbeat.top/" target="_blank">动脉网</a> -->
            <a href="http://vcearth.com/" target="_blank">35斗</a>
          </div>
        </div>
        <div class="er_img">
          <div class="er_div">
            <img :src="$store.state.static_img_url + 'pic/index/dmc.png'" />
            <p>动脉橙产业智库</p>
          </div>
          <div class="er_div">
            <img :src="$store.state.static_img_url + 'pic/index/dmc-xcx.png'" />
            <p>动脉橙</p>
          </div>
        </div>
      </div>
      <div class="copyright">
        <a href="http://beian.miit.gov.cn" target="_blank" style="display:inline-block;text-decoration:none;height:16px;line-height:16px;font-size: 12px;color:#e9e9e9;vertical-align: top;margin-right: 15px;">© 动脉 渝ICP备18013108号-4</a>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50011202502165" style="display:inline-block;text-decoration:none;height:16px;line-height:16px;">
          <img :src="$store.state.img_req_url + '/upload/vcbeat/public/images/pb-icon.png'" style="float:left;width:16px;"/>
          <p style="float:left;height:16px;line-height:16px;margin: 0px 0px 0px 5px; color:#e9e9e9;">渝公网安备 50011202502165号</p>
        </a>
      </div>
      <Contact :contactModel="contact_model" @contactCb="contactCb"></Contact>
    </div>
</template>
<script>
import Contact from '@/components/Contact.vue'
export default {
    data() {
        return {
            contact_model: false
        }
    },
    components: {
        Contact
    },
    methods: {
        handleClickIndex() {
            if(this.$route.name != 'About') {
                this.$router.push({name: 'About'})
            }
        },
        contactCb(bl) {
            this.contact_model = bl
            if(!bl) {
                document.body.style.paddingRight = ''
                document.body.style.overflow = ''
            }
        }
    }
}
</script>
<style lang="stylus" scoped>
.footer
  background: url('~pic/index/footer.png') no-repeat;
  background-size: 100% 284px;
  bottom: 0;
  width: 100%;
  .content
    position: relative;
    width: 1200px;
    margin: 0 auto;
    padding: 37px 0 27px 0;
    font-size: 14px;
    line-height: 20px;
    color: rgba(188, 189, 193, 1);
    border-bottom 1px solid rgba(255, 255, 255, 0.2)
  .msg
    i
      margin-right: 13px;
    p
      display: flex;
      align-items: center;
      margin-bottom: 8px;
  .hrefs
    margin-top: 14px;
    .title
      font-weight: 600;
      color: rgba(233, 233, 235, 1);
      > span
        color: #E9E9EB
        margin-left: 41px
        cursor: pointer
        position: relative
        &:first-of-type
          margin-left 0
          &:before
            content none
          &:hover
            color: #E9E9EB
        &:before
          content: ''
          position: absolute
          width: 2px
          height: 14px
          background: rgba(255, 255, 255, 0.2)
          left: -21px
          top: 1px
        &:hover
          color: rgba(250, 122, 80, 1);
    > div a
      display: inline-block;
      color: rgba(188, 189, 193, 1);
      margin: 8px 29px 0 0;
      white-space: nowrap;
      &:hover
        color: rgba(250, 122, 80, 1);
  .er_img
    position: absolute;
    top: 39px;
    right: 0;
    text-align: center;
    .er_div
      float: left;
      &+.er_div
        margin-left: 30px
    img
      width: 84px;
  .copyright
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 12px;
    color: #AAAAAA;
    display: flex;
    justify-content: center;
    align-items: center;
</style>